var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.solicitacao
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "card-container" },
            [
              _c("p", { staticClass: "historico-label" }, [
                _vm._v("Mensagem " + _vm._s(_vm.solicitacao.numero))
              ]),
              _c("div", { staticClass: "label-descricao" }, [
                _c("span", { staticClass: "negrito" }, [_vm._v("Descrição:")]),
                _c("span", { staticClass: "space-left" }, [
                  _vm._v(_vm._s(_vm.solicitacao.descricao || "-"))
                ])
              ]),
              _c(
                "div",
                { staticClass: "cartorio-pesquisa" },
                [
                  _c(
                    "el-collapse",
                    {
                      attrs: { value: "0" },
                      model: {
                        value: _vm.collapseActive,
                        callback: function($$v) {
                          _vm.collapseActive = $$v
                        },
                        expression: "collapseActive"
                      }
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { name: "0" } },
                        [
                          _c("template", { slot: "title" }, [
                            _c(
                              "div",
                              { staticClass: "container-title-collapse" },
                              [
                                _c("div", [
                                  _c("span", { staticClass: "nome-collpase" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.ORIGEM[
                                          _vm.solicitacao.mensagemCartorios[0]
                                            .origem
                                        ]
                                      )
                                    )
                                  ]),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        " - " +
                                          _vm.solicitacao.mensagemCartorios[0]
                                            .remetente.nome
                                      )
                                    )
                                  ])
                                ]),
                                _c("div", { staticClass: "data-collapse" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.titleCollapseMensagemData(
                                        _vm.solicitacao.mensagemCartorios[0]
                                      )
                                    )
                                  )
                                ])
                              ]
                            )
                          ]),
                          _c("visualizar-mensagem", {
                            attrs: {
                              mensagem: _vm.solicitacao.mensagemCartorios[0],
                              solicitacao: _vm.solicitacao,
                              ultima: true
                            }
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.solicitacao.mensagemCartorios.length > 1
                ? _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { lg: 24, md: 24, sm: 24 } },
                        [
                          _c("p", { staticClass: "historico-label" }, [
                            _vm._v("Histórico")
                          ]),
                          _vm._l(_vm.solicitacao.mensagemCartorios, function(
                            item,
                            index
                          ) {
                            return _c("div", [
                              index !== 0
                                ? _c(
                                    "div",
                                    { staticClass: "cartorio-pesquisa" },
                                    [
                                      _c(
                                        "el-collapse",
                                        {
                                          attrs: { value: index },
                                          on: { change: _vm.openCollapse }
                                        },
                                        [
                                          _c(
                                            "el-collapse-item",
                                            { attrs: { name: "collapsed" } },
                                            [
                                              _c(
                                                "template",
                                                { slot: "title" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "container-title-collapse"
                                                    },
                                                    [
                                                      _c("div", [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "nome-collpase"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.ORIGEM[
                                                                  item.origem
                                                                ]
                                                              )
                                                            )
                                                          ]
                                                        ),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              " - " +
                                                                item.remetente
                                                                  .nome
                                                            )
                                                          )
                                                        ])
                                                      ]),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "data-collapse"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.titleCollapseMensagemData(
                                                                item
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c("visualizar-mensagem", {
                                                attrs: {
                                                  mensagem: item,
                                                  solicitacao: _vm.solicitacao
                                                }
                                              })
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          })
                        ],
                        2
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            {
              staticClass: "container-buttons",
              attrs: { lg: 24, md: 24, sm: 24 }
            },
            [
              _c(
                "el-button",
                { staticClass: "btn-voltar", on: { click: _vm.voltar } },
                [
                  _c("i", { staticClass: "fas fa-chevron-left" }),
                  _c("span", { staticClass: "space-left" }, [_vm._v("Voltar")])
                ]
              ),
              _c(
                "div",
                [
                  _vm.solicitacao.status !== "FINALIZADA" &&
                  _vm.solicitacao.status === "AGUARDANDO_RESPOSTA_SICARF"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-info",
                          on: { click: _vm.goResponder }
                        },
                        [_vm._v("Responder")]
                      )
                    : _vm._e(),
                  _vm.solicitacao.status !== "FINALIZADA" &&
                  _vm.solicitacao.origem === "SICARF" &&
                  _vm.solicitacao.status !== "AGUARDANDO_RESPOSTA_SICARF"
                    ? _c(
                        "el-button",
                        {
                          staticClass: "btn-success",
                          on: { click: _vm.finalizar }
                        },
                        [
                          _c("i", { staticClass: "fas fa-check" }),
                          _c("span", { staticClass: "space-left" }, [
                            _vm._v("Finalizar")
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-487de0ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-487de0ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/Visualizar.vue
// module id = null
// module chunks = 